// extracted by mini-css-extract-plugin
module.exports = {"twoColumn":"TwoColumn_twoColumn__DZ-Bw","twoColumnItem":"TwoColumn_twoColumnItem__35ZTT"};